

import React from 'react';
import styled from 'styled-components';

const StyleWrapper = styled.div``;

const PodcastSAP = function PodcastSAP() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="109" height="95" viewBox="0 0 109 95" fill="none">
      <path d="M18.3534 84.3225C23.5883 90.4028 31.2901 94.2485 39.8822 94.2485H70.0792C78.453 94.2485 85.985 90.6003 91.2095 84.7868C91.1368 82.7704 91.0432 81.589 91.0432 81.589H18.5023C18.5023 81.589 18.4261 82.5902 18.3534 84.326V84.3225Z" fill="url(#paint0_linear_217_94)" />
      <path d="M52.5034 34.2808L54.3327 3.77533L55.1711 3.76147L57.43 34.9806L52.5034 34.2808Z" fill="#001760" />
      <path d="M54.738 4.21863C55.8459 4.21863 56.744 3.32051 56.744 2.21264C56.744 1.10476 55.8459 0.206665 54.738 0.206665C53.6301 0.206665 52.7321 1.10476 52.7321 2.21264C52.7321 3.32051 53.6301 4.21863 54.738 4.21863Z" fill="#26CF0A" />
      <path d="M98.6272 42.6926H89.1031C83.3743 42.6926 78.7302 47.3367 78.7302 53.0655V60.6321C78.7302 66.3609 83.3743 71.005 89.1031 71.005H98.6272C104.356 71.005 109 66.3609 109 60.6321V53.0655C109 47.3367 104.356 42.6926 98.6272 42.6926Z" fill="#001760" />
      <path d="M20.827 42.6926H11.3029C5.57413 42.6926 0.930054 47.3367 0.930054 53.0655V60.6321C0.930054 66.3609 5.57413 71.005 11.3029 71.005H20.827C26.5558 71.005 31.1999 66.3609 31.1999 60.6321V53.0655C31.1999 47.3367 26.5558 42.6926 20.827 42.6926Z" fill="#001760" />
      <path d="M74.3267 22.2552H35.6068C21.8838 22.2552 10.759 33.38 10.759 47.103V66.5912C10.759 80.3142 21.8838 91.439 35.6068 91.439H74.3267C88.0498 91.439 99.1745 80.3142 99.1745 66.5912V47.103C99.1745 33.38 88.0498 22.2552 74.3267 22.2552Z" fill="#26CF0A" />
      <path d="M74.6766 31.3809H35.2534C26.7712 31.3809 19.895 38.257 19.895 46.7392V66.9584C19.895 75.4406 26.7712 82.3168 35.2534 82.3168H74.6766C83.1588 82.3168 90.035 75.4406 90.035 66.9584V46.7392C90.035 38.257 83.1588 31.3809 74.6766 31.3809Z" fill="white" />
      <path d="M34.2382 54.0909H30.8429V60.5246H34.2382V54.0909Z" fill="#26CF0A" />
      <path d="M39.0644 53.1068H35.6692V61.5049H39.0644V53.1068Z" fill="#26CF0A" />
      <path d="M43.887 50.5155H40.4917V64.0966H43.887V50.5155Z" fill="#26CF0A" />
      <path d="M48.7133 49.1572H45.318V65.458H48.7133V49.1572Z" fill="#26CF0A" />
      <path d="M53.5359 49.1572H50.1406V65.458H53.5359V49.1572Z" fill="#26CF0A" />
      <path d="M58.362 50.5155H54.9667V64.0966H58.362V50.5155Z" fill="#26CF0A" />
      <path d="M63.1881 53.1068H59.7928V61.5049H63.1881V53.1068Z" fill="#26CF0A" />
      <path d="M77.3893 53.1068H73.994V61.5049H77.3893V53.1068Z" fill="#26CF0A" />
      <path d="M68.0108 50.5155H64.6155V64.0966H68.0108V50.5155Z" fill="#26CF0A" />
      <path d="M72.8368 49.1572H69.4415V65.458H72.8368V49.1572Z" fill="#26CF0A" />
      <defs>
        <linearGradient id="paint0_linear_217_94" x1="54.7589" y1="94.0579" x2="54.7797" y2="85.0224" gradientUnits="userSpaceOnUse">
          <stop stop-color="#21AD04" />
          <stop offset="1" stop-color="#26CF0A" />
        </linearGradient>
        <radialGradient id="paint1_radial_217_94" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(55.9006 56.8488) scale(36.9552 24.4736)">
          <stop stop-color="#26CF0A" />
          <stop offset="0.23" stop-color="#43B430" />
          <stop offset="0.52" stop-color="#64985B" />
          <stop offset="0.75" stop-color="#788676" />
          <stop offset="0.88" stop-color="#808080" />
        </radialGradient>
      </defs>
    </svg>
  );
};
export default PodcastSAP;